// Constants.
import * as PayConnectedPackagesConstants from 'constants/PayConnectedPackagesConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';

const initialState = {
  isFetching: false,
  isFetched: false,
  cancelPayConnectedPackages: false,
  errorMessage: '',
};

export default function products(state = initialState, action = {}) {
  switch (action.type) {
    case PayConnectedPackagesConstants.CANCEL_PAY_CONNECTED_PACKAGE_REQUEST:
      return {
        ...state,
        isFetching: true,
        isFetched: false,
      };
    case PayConnectedPackagesConstants.CANCEL_PAY_CONNECTED_PACKAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        cancelPayConnectedPackages: true,
      };
    case PayConnectedPackagesConstants.CANCEL_PAY_CONNECTED_PACKAGE_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        errorMessage: action.response.details,
      };
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        cancelPayConnectedPackages: false,
        errorMessage: '',
      };
    default:
      return state;
  }
}
